import { Injectable } from '@angular/core';
import { initializeEcho, getEcho, destroyEcho } from '../../config/laravel-echo';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EchoService {

  private echo: any = null;

  private userChannel: any;
  private onboardingWebChannel: any;
  private learningWebChannel: any;
  private performanceWebChannel: any;
  private performanceChannelName: string | null = null;
  private globalUser: any;

  constructor() { }

  setChannels(user, token, configData) {
    if(!configData?.settings?.sockets?.webapp?.enabled ||
      !configData?.settings?.sockets?.webapp?.credentials?.appKey ||
      !configData?.settings?.sockets?.webapp?.credentials?.host
    ) {
      // console.log("setChannels...3");
      return;
    }
    console.log("setChannels...2");
    let pusherApiUrl = environment.MIX_PUSHER_BACKEND_API;
    if(environment.APP_MULTIMARCA) {
      const apiUrlForBrand = JSON.parse(localStorage.getItem("api_urls"));
      pusherApiUrl = apiUrlForBrand.serviceBase;
    };

    this.echo = initializeEcho(token, configData?.settings?.sockets?.webapp?.credentials?.appKey, configData?.settings?.sockets?.webapp?.credentials?.host, pusherApiUrl );
    // this.echo.connector.options.auth.headers.Authorization = 'Bearer ' + token

    // todos
    this.userChannel =  this.echo.private('users.' + user.id);
    this.userChannel.notification((notification) => {
      console.log('notification');
      console.log(notification);
    });

    this.globalUser = this.echo.join('global.users');
    this.globalUser.listen('TestEventChannel', (e) => {
        console.log('TestEventChannel global-user');
        console.log(e);
    })
    .error((error) => {
        console.error('error');
        console.error(error);
    });


    if(user.onboarding) {
        // solo desde inducción
        //  this.onboardingWebUsersChannel = this.echo.private('onboarding.web.users.' + user.id);
        // this.onboardingWebUsersChannel.notification((notification) => {
        //   console.log('notification');
        //   console.log(notification);
        // });

        this.onboardingWebChannel = this.echo.join('onboarding.web');
        this.onboardingWebChannel
        .listen('TestEventChannel', (e) => {
            console.log('TestEventChannel');
            console.log(e);
        })
        .error((error) => {
            console.error('error');
            console.error(error);
        });

    } else {
      // solo desde aprendizaje/capacitación

      this.learningWebChannel = this.echo.join('learning.web');

      this.learningWebChannel
      .listen('TestEventChannel', (e) => {
          console.log('TestEventChannel');
          console.log(e);
      })
      .error((error) => {
          console.error('error');
          console.error(error);
      });

    };

  }

  // Canal de presencia del módulo de Desempeño: `performance.web.<slug del workspace>`.
  // A diferencia de learning.web / onboarding.web —que se resuelven una sola vez al
  // iniciar sesión— a Desempeño se entra y se sale dentro de la misma sesión (desde el
  // side-menu), así que este canal se sincroniza con la ruta: se entra al llegar a
  // /performance y se sale al abandonar el módulo. Lo autoriza el backend de Desempeño con
  // su propio token (ver config/laravel-echo.ts), que exige que el usuario pertenezca a ese
  // workspace. Ambos métodos son idempotentes y no hacen nada si los sockets están apagados
  // para el workspace (this.echo === null) o si todavía no se conoce el slug.
  joinPerformanceChannel(workspaceSlug: string) {
    if (!this.echo || this.performanceWebChannel || !workspaceSlug) {
      return;
    }

    this.performanceChannelName = 'performance.web.' + workspaceSlug;
    this.performanceWebChannel = this.echo.join(this.performanceChannelName);

    this.performanceWebChannel
    .error((error) => {
        console.error('error performance.web');
        console.error(error);
    });
  }

  leavePerformanceChannel() {
    if (!this.echo || !this.performanceWebChannel) {
      return;
    }

    // Echo antepone el prefijo del tipo de canal: sale de 'presence-performance.web.<slug>'.
    this.echo.leave(this.performanceChannelName);
    this.performanceWebChannel = null;
    this.performanceChannelName = null;
  }


  leaveAllChannels() {
    console.log("Leaving all Echo channels..1.", this.userChannel, this.learningWebChannel);

    // Desuscribirse de canales privados
    if (this.userChannel) {
      this.echo.leave('private-users.' + this.getUserIdFromChannel(this.userChannel));
      this.userChannel = null;
    }

    // Desuscribirse de canales de presencia
    if (this.onboardingWebChannel) {
      this.echo.leave('presence-onboarding.web');
      this.onboardingWebChannel = null;
    }

    if (this.learningWebChannel) {
      this.echo.leave('presence-learning.web');
      this.learningWebChannel = null;
    }

    this.leavePerformanceChannel();

    if (this.globalUser) {
      this.echo.leave('presence-global.users');
      this.globalUser = null;
    }

    console.log("Leaving all Echo channels..2.", this.userChannel, this.learningWebChannel);

    // if (this.echo && this.echo.connector && this.echo.connector.options && this.echo.connector.options.auth) {
    //   this.echo.connector.options.auth.headers.Authorization = '';
    // }

    // Descarta también la instancia del módulo de config, no solo esta referencia: si
    // sobrevive desconectada, el siguiente setChannels() la reutiliza con el token viejo
    // y los canales no vuelven a conectar hasta recargar la app.
    destroyEcho();
    this.echo = null;
  }

  private getUserIdFromChannel(channel): string {
    if (!channel) return '';

    const channelName = channel.name;
    const parts = channelName.split('.');
    return parts[parts.length - 1];
  }
}
